import api from "@/api";

export default {
  // Lấy danh sách đề xuất của 1 công trình
  getByCongTrinh(congTrinhId) {
    return api.get(`/api/cong-trinh/${congTrinhId}/de-xuat`);
  },

  // Tạo đề xuất mới
  create(congTrinhId, data) {
    return api.post(`/api/cong-trinh/${congTrinhId}/de-xuat`, data);
  },

  // Cập nhật nội dung (Items, Ghi chú, Ảnh)
  update(id, data) {
    return api.put(`/api/cong-trinh/de-xuat/${id}`, data);
  },

  // Duyệt hoặc Từ chối (Body: { approved: true/false, reason: "..." })
  approve(deXuatId, payload) {
    return api.put(`/api/cong-trinh/de-xuat/${deXuatId}/duyet`, payload);
  },

  // Xác nhận nhận hàng (Body: { images: ["url1", "url2"] })
  confirm(deXuatId, payload) {
    return api.put(`/api/cong-trinh/de-xuat/${deXuatId}/xac-nhan`, payload);
  },
};